<mat-toolbar *ngIf="toolbarConfig" color="primary">

  <button *ngIf="toolbarConfig.backAction" mat-icon-button (click)="onBack()" [disabled]="toolbar.navigationBlocked$ | async">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <span *ngIf="toolbarConfig.title" class="toolbar-title">{{ toolbarConfig.title }}</span>

  <!-- This fills the remaining space of the current row -->
  <span class="toolbar-spacer"></span>

  <button mat-icon-button (click)="locationButtonClicked()" [disabled]="locationBusy">
    <mat-icon>{{ locationIconName }}</mat-icon>
  </button>
  <button mat-icon-button (click)="toggleSounds()">
    <mat-icon *ngIf="soundsEnabled">volume_up</mat-icon>
    <mat-icon *ngIf="!soundsEnabled">volume_off</mat-icon>
  </button>
  <button *ngIf="shouldShowLogout" mat-icon-button (click)="logoutButtonClicked()">
    <mat-icon>exit_to_app</mat-icon>
  </button>
  <button *ngIf="toolbarConfig.showSettings" mat-icon-button (click)="settingsButtonClicked()" [disabled]="toolbar.navigationBlocked$ | async">
    <mat-icon>settings</mat-icon>
  </button>
  <button *ngIf="toolbarConfig.showCall" mat-icon-button (click)="callButtonClicked()">
    <mat-icon>call</mat-icon>
  </button>
  <button *ngIf="toolbarConfig.showRefresh" mat-icon-button (click)="refreshButtonClicked()">
    <mat-icon>sync</mat-icon>
  </button>

</mat-toolbar>
